import type { ReactNode } from 'react';
import { Checkbox } from '@/components/forms';

export type ChartLegendProps = {
  items: { label: ReactNode; value: ReactNode; color?: string }[];
  /** Série de comparação ligável (ex.: "Mês anterior"). */
  compare?: { label: ReactNode; ariaLabel: string; value: ReactNode; checked?: boolean; onChange?: (checked: boolean) => void };
};

/** Legenda do gráfico com o valor de cada série (`.legend`). */
export function ChartLegend({ items, compare }: ChartLegendProps) {
  return (
    <div className="legend">
      {items.map((it, i) => (
        <div className="k" key={i}><i style={it.color ? { background: it.color } : undefined}></i>{it.label} <span>{it.value}</span></div>
      ))}
      {compare && (
        <label>
          <Checkbox aria-label={compare.ariaLabel} checked={compare.onChange ? !!compare.checked : undefined} onChange={compare.onChange ? (e) => compare.onChange?.(e.target.checked) : undefined} />
          <span>{compare.label}</span>
          <span className="v">{compare.value}</span>
        </label>
      )}
    </div>
  );
}
